import { Button, ButtonGroup } from 'components/ui/button';
import { space } from 'helpers/style';
import React from 'react';
import styled from 'styled';
import { theme } from 'styled/theme';
import { QueryStatus, QUERY_STATUS } from '../queryStatus';
import { QuerySummary } from './query-summary';


type Props = {
  status: QueryStatus;
  onStyleToggle: () => void;
  onNewQuery: () => void;
  className?: string;
}

const StyledSection = styled.section`

  padding: ${space(2)};
  padding-bottom: 0; 
  display: flex;
  flex-direction: row;
  gap: .75em;
  align-items: center;
  justify-content: flex-end;

  > *:nth-last-child(2) {
    flex-grow:1;
  }

  font-size: .9em;

  button:only-child {
    justify-self: end;
  }
`

const ErrorMessage = styled.p`
  color: ${theme.color.error};
`

const getMessageElement = (status: QueryStatus) => {
  switch (status.type) {
    case QUERY_STATUS.READY: {
      return <p>Ready to query</p>
    }
    case QUERY_STATUS.LOADING: {
      return <p>Preparing your report (Visitor Traffic Queries take 2min per month of data)</p>
    }
    case QUERY_STATUS.ERROR: {
      return <ErrorMessage>{status.errorMessage}</ErrorMessage>
    }
    case QUERY_STATUS.SUCCESS: {
      return <QuerySummary query={status.queryProps} />
    }
    default: 
        return null
  }
}

const StatusBar: React.FC<Props> = ({onStyleToggle, onNewQuery, status, className}) => (
  <StyledSection className={className}>
    {getMessageElement(status)}
    <ButtonGroup>
      <Button 
        isSmall
        onClick={onStyleToggle} >
        Toggle Map Style
      </Button>
      <Button
        isSmall
        onClick={onNewQuery}
        >
        New Query
      </Button> 
    </ButtonGroup>
  </StyledSection>
);

export { StatusBar }